(ns net.kestec.mhda-pilgrimage.admin.popup.application-payment-popup
  (:require ["@mui/material/Button" :default Button]
            ["@mui/material/Modal" :default Modal]
            ["@mui/material/Grid" :default Grid]
            ["@mui/material/TextField" :default TextField]
            ["@mui/material/FormLabel" :default FormLabel]
            ["@mui/material/Select" :default Select]
            ["@mui/material/MenuItem" :default MenuItem]
            ["@mui/icons-material/Cancel" :default CancelIcon]
            ["@mui/icons-material/Done" :default DoneIcon]

            [ajax.core :as ajax]
            [net.kestec.mhda-pilgrimage.db :as-alias db]
            [net.kestec.mhda-pilgrimage.admin.applications.applications-events :as-alias admin-applications-events]
            [net.kestec.mhda-pilgrimage.admin.applications.application-events :as-alias admin-application-events]
            [net.kestec.re-frame.event :as-alias event]
            ["react" :as react]
            [re-frame.core :as rf]
            [reagent.core :as r]))




(defn claim-payment-form* [application]
  (let [applicationId (:id application)
        paid_sum (:paid_sum application)
        !sum (r/atom 00.0)]
    ;(println "claim-status-form* " claim)

    [:div
     {:class "modal"
      :style {:min-width "600px"}}
     [:h2 "Einzahlung bearbeiten"]
     [:h4 (:shown_first_name application) " " (:shown_family_name application)]
     [:br]
     [:div
      [:> Grid {:container  true
                :direction  "row"
                :justify    "center"
                :alignItems "flex-start"
                :spacing    2}

       ;[:> Grid {:item true :xs 12} (pr-str claim)]
       [:> Grid {:item true :xs 12}
        [:> TextField
         {:label           "Betrag"
          :type            "number"
          :step            "any"
          :size            "small"
          :fullWidth       true
          :defaultValue    paid_sum
          :InputLabelProps {:disableAnimation true :shrink true}
          :InputProps      {:inputProps {:min 36 :max 40}}
          :onChange        #(reset! !sum (.. % -target -value))}
         ]]

       [:> Grid {:item true :xs 12}]]]
     [:br]
     [:br]

     [:> Button
      {:style     {:float "left"}
       :variant   "outlined"
       :startIcon (r/as-element [:> CancelIcon])
       :onClick   #(rf/dispatch [::admin-applications-events/set-payment-popup-application nil])
       }
      "Abbrechen"]

     [:> Button
      {:style     {:float "right"}
       :variant   "contained"
       :startIcon (r/as-element [:> DoneIcon])
       :onClick   (fn []
                    ;(println "lölöl" @!sum)
                    (rf/dispatch [::admin-application-events/update-application applicationId {:paid_sum @!sum}])
                    (rf/dispatch [::admin-applications-events/set-payment-popup-application nil]))
       }
      "ok"]
     ]

    ))

(defn application-payment-popup []
  (when-let [application-id @(rf/subscribe [::db/get ::db/payment-popup-application])]
    (let [application (first (filter #(= application-id (:id %)) @(rf/subscribe [::db/get ::admin-applications-events/admin-applications])))]
      [:> Modal {:aria-labelledby  "simple-modal-title"
                 :aria-describedby "simple-modal-description"
                 :style            {:display        "flex"
                                    :marginRight    "auto"
                                    :marginLeft     "auto"
                                    :alignItems     "center"
                                    :justifyContent "center"}
                 :open             (if (nil? application-id) false true)

                 }
       [:f> claim-payment-form* application]]
      )))